<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="NewPremise"
    title="New Premise"
    submit-name="Create"
    full-height
    disable-tabindex
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <template v-if="currentLandscape">
      <lm-actor-select
        ref="actorSelect"
        class="mb-8"
        :selected-actor="selectedActor"
      >
        Add premise to:
      </lm-actor-select>
      <div class="md:flex">
        <lm-date-begin-end-input
          ref="inputBeginEndDate"
          class="mr-8"
          @submit="submitFromInput"
        />
        <lm-currency-select ref="inputBudget" @submit="submitFromInput" />
      </div>
      <lm-input
        ref="inputTitle"
        label="Title"
        :maxlength="200"
        @submit="submitFromInput"
      />
      <lm-editor
        ref="inputDescription"
        v-model="description"
        label="description"
        class="mt-12"
        @submit="submitFromInput"
      />

      <lm-editor
        ref="inputActionPlan"
        v-model="actionPlan"
        label="action plan"
        class="mt-12"
        @submit="submitFromInput"
      />
      <related-topics
        ref="relatedTopics"
        :temp-topics="tempTopics"
        no-required
      />
    </template>
  </form-modal>
</template>

<script>
import LmActorSelect from '@/components/form/LmActorSelect'
import LmEditor from '@/components/form/LmEditor'
import RelatedTopics from '@/components/landscape/common/RelatedTopics'
import {Events, Modal} from '@/lib/definitions'
import {mapGetters} from 'vuex'
import EventHub from '@/lib/eventHub'
import FormModal from '@/components/modals/FormModal'
import LmInput from '@/components/form/LmInput.vue'
import LmDateBeginEndInput from '@/components/form/LmDateBeginEndInput.vue'
import LmCurrencySelect from '@/components/form/LmCurrencySelect.vue'
import FormHelper from '@/components/form/formHelper'
import {imgInHTMLResize} from './Topic/resizeImagesInHTML'

export default {
  name: 'ModalNewPremise',
  components: {
    RelatedTopics,
    LmEditor,
    LmActorSelect,
    FormModal,
    LmInput,
    LmDateBeginEndInput,
    LmCurrencySelect
  },
  data() {
    return {
      Events,
      Modal,
      modalName: Modal.NEW_PREMISE,
      modalRef: null,
      inputs: null,
      description: '',
      actionPlan: ''
    }
  },
  computed: {
    ...mapGetters(['selectedActor', 'currentLandscape']),
    ...mapGetters({tempTopics: 'premises/helpers/tempTopics'})
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.inputs = [
      this.$refs.actorSelect,
      this.$refs.inputTitle,
      this.$refs.inputDescription,
      this.$refs.inputActionPlan,
      this.$refs.inputBudget,
      this.$refs.inputBeginEndDate,
      this.$refs.relatedTopics
    ]
  },
  methods: {
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      if (FormHelper.validate(this.inputs)) {
        imgInHTMLResize(this.description).then(resizedImgsText => {
          const {beginDate, endDate} = this.$refs.inputBeginEndDate.getData()
          let payload = {
            actorId: this.$refs['actorSelect'].data,
            title: this.$refs.inputTitle.data,
            text: resizedImgsText,
            topics: this.tempTopics,
            actionPlan: this.actionPlan,
            beginAt: beginDate,
            endAt: endDate,
            budget: this.$refs.inputBudget.getData(),
            mentions: FormHelper.getEditorMentions()
          }
          this.$store
            .dispatch('premises/create', payload)
            .then(() => this.modalRef.submitSuccess())
            .catch(error => this.modalRef.submitFails(error))
        })
      } else {
        this.modalRef.submitFails()
      }
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        EventHub.emit(Events.SHOW_SNACKBAR, 'New Premise created')
      }
    }
  }
}
</script>
